import React from 'react';
import { Row, Col } from 'antd';
import { EnvironmentOutlined, LineChartOutlined, WarningOutlined, ClockCircleOutlined } from '@ant-design/icons';
import '../styles/ply3DTooltip.css'; // Using exact same CSS as 3D tooltip

function RmsSegmentTooltip({ feature }) {
  const props = feature?.properties || {};

  // Format the timestamp to a readable format
  const formatTimestamp = (timestamp) => {
    if (!timestamp) return 'N/A';

    try {
      const date = new Date(timestamp);
      if (isNaN(date.getTime())) return timestamp; // Return original if invalid

      // Format as: "21 Nov 2025, 10:24:57"
      const options = {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
      };

      return date.toLocaleDateString('en-GB', options).replace(',', ' •');
    } catch (error) {
      return timestamp;
    }
  };

  // Get color based on RMS value (matching the line color)
  const getColorFromRms = () => {
    return props.color || '#FFFF00';
  };

  const rmsColor = getColorFromRms();

  return `
    <div class="rms-popup-content">
      <div style="padding: 16px;">
        <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 16px;">
          <h4 style="margin: 0; font-size: 16px; font-weight: bold; color: #333; display: flex; align-items: center; gap: 8px;">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M3 7L21 7" stroke="${rmsColor}" stroke-width="2" stroke-linecap="round"/>
              <path d="M3 12L21 12" stroke="${rmsColor}" stroke-width="2" stroke-linecap="round"/>
              <path d="M3 17L21 17" stroke="${rmsColor}" stroke-width="2" stroke-linecap="round"/>
              <circle cx="7" cy="7" r="2" fill="${rmsColor}"/>
              <circle cx="12" cy="12" r="2" fill="${rmsColor}"/>
              <circle cx="17" cy="17" r="2" fill="${rmsColor}"/>
            </svg>
            RMS Segment
          </h4>
        </div>

        <div style="background: linear-gradient(135deg, ${rmsColor}15 0%, ${rmsColor}05 100%);
                    border-left: 4px solid ${rmsColor};
                    padding: 12px;
                    border-radius: 6px;
                    margin-bottom: 16px;">
          <div style="font-size: 12px; color: #666; margin-bottom: 6px; font-weight: 600;">RMS XYZ Value</div>
          <div style="font-size: 22px; font-weight: bold; color: ${rmsColor};">
            ${props.rms_XYZ?.toFixed(4) || 'N/A'}
          </div>
        </div>

        <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 12px; margin-bottom: 16px;">
          <div style="padding: 10px; background: #f8f8f8; border-radius: 6px;">
            <div style="font-size: 11px; color: #666; margin-bottom: 4px; font-weight: 600;">ANOMALIES</div>
            <div style="font-size: 18px; font-weight: bold; color: #333;">
              ${props.anomaly_count || 0}
            </div>
          </div>
          <div style="padding: 10px; background: #f8f8f8; border-radius: 6px;">
            <div style="font-size: 11px; color: #666; margin-bottom: 4px; font-weight: 600;">STATUS</div>
            <div style="display: inline-flex; align-items: center; gap: 6px; margin-top: 8px;">
              <div style="width: 30px; height: 6px; background: ${rmsColor}; border-radius: 3px;"></div>
            </div>
          </div>
        </div>

        <div style="border-top: 1px solid #e8e8e8; padding-top: 12px; margin-top: 12px;">
          <div style="font-size: 11px; color: #666;">
            <div style="margin-bottom: 4px; display: flex; align-items: center; gap: 6px;">
              <strong>Start:</strong> ${formatTimestamp(props.timestamp_start).split('•')[1]?.trim() || 'N/A'}
            </div>
            <div style="display: flex; align-items: center; gap: 6px;">
              <strong>End:</strong> ${formatTimestamp(props.timestamp_end).split('•')[1]?.trim() || 'N/A'}
            </div>
          </div>
        </div>
      </div>
    </div>
  `;
}

export default RmsSegmentTooltip;